import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePreviewModal } from '../hooks/useModulePreviewStore';
import InfoBar from '../../../navigation/components/InfoBar';

/**
 * Header component for the module preview
 * Shows title, module name, navigation controls, and close button
 */
const ModulePreviewHeader = ({ onExit }) => {
  const { t } = useTranslation();
  const { closePreview } = usePreviewModal();

  const handleClose = () => {
    closePreview();
    if (typeof onExit === 'function') {
      onExit();
    }
  };

  return (
    <InfoBar
      message={t('common.components.modulePreview.header.title')}
      level="info"
      buttonLabel={t('common.components.modulePreview.header.close')}
      onButtonPress={handleClose}
    />
  );
};

export default ModulePreviewHeader;
